export default __webpack_public_path__ + "static/media/profile-arrow-orange-icon.b4ceed95.svg";